import {
  formatActivitySphereLabel,
  useGetActivitySphere,
} from '@entities/activitySphere';
import { TagsInput, type TagsInputProps } from '@mantine/core';

type ActivitySphereTagsInputProps = {
  placeholder?: string;
} & TagsInputProps;

export const ActivitySphereTagsInput = ({
  placeholder,
  ...props
}: ActivitySphereTagsInputProps) => {
  const { data } = useGetActivitySphere();

  const displayPlaceholder =
    props.value && !!props.value.length ? '' : placeholder;

  return (
    <TagsInput
      data={data?.map(item => ({
        label: formatActivitySphereLabel(item),
        value: item.id.toString(),
      }))}
      variant='filled'
      limit={10}
      placeholder={displayPlaceholder}
      {...props}
    />
  );
};
